import {Component, ElementRef, HostListener, Input} from '@angular/core';
import {NgIf, NgForOf, NgClass, SlicePipe, DatePipe} from "@angular/common";
import { Company } from 'src/app/interfaces/company.interface';
import { sameCompanyName } from 'src/app/utils/normalize-company.util';
import {SharedService} from "../../../../../services/shared.service";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {MatTooltip} from "@angular/material/tooltip";

@Component({
  selector: 'app-change-company',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    NgClass,
    MatTooltip,
    SlicePipe,
    DatePipe
  ],
  templateUrl: './change-company.component.html',
  styleUrl: './change-company.component.scss',
  animations: [
    trigger('dropdownAnimation', [
      state('void', style({
        opacity: 0,
        transform: 'scale(0.95)'
      })),
      state('visible', style({
        opacity: 1,
        transform: 'scale(1)'
      })),
      transition('void => visible', [
        animate('100ms ease-out')
      ]),
      transition('visible => void', [
        animate('75ms ease-in')
      ])
    ])
  ]
})
export class ChangeCompanyComponent {

  @Input() reportSearch: any;
  @Input() companies: any[] = [];
  @Input() company: Company;

  isOpen = false;

  // Company switching now works off Apollo employment_history (matched by name).
  // Flip back to true to disable the picker again.
  isComingSoon = false;

  constructor(private sharedService: SharedService, private elementRef: ElementRef) {
    //
  }

  /** True when there is at least one company in the list other than the active one. */
  get hasSwitchableCompany(): boolean {
    return (this.companies || []).some((item) => !this.isActiveCompany(item));
  }

  get canChangeCompany(): boolean {
    if (this.isComingSoon) {
      return false;
    }
    // Only once the report has finished gathering data AND there is another
    // company to switch to.
    return this.reportSearch?.search_status_id === 3 && this.hasSwitchableCompany;
  }

  get tooltipMessage(): string {
    if (this.isComingSoon) {
      return 'Company switching available soon';
    }
    if (this.reportSearch?.search_status_id !== 3) {
      return 'Report is still gathering data';
    } else if (!this.hasSwitchableCompany) {
      return 'No other companies to switch to';
    }
    return '';
  }

  /** Whether a dropdown item is the company currently being displayed. */
  isActiveCompany(item: any): boolean {
    return sameCompanyName(item?.name, this.company?.name);
  }

  handleIsOpen(): void {
    // Only allow toggling if conditions are met
    if (this.canChangeCompany) {
      this.isOpen = !this.isOpen;
    }
  }

  selectCompany(company: any): void {
    console.log('[change-company] selectCompany')

    // Emit this event and listen inside change-company-modal
    this.sharedService.emitChangeCompany(company);

    this.handleIsOpen();
  }

  // HostListener for closing the dropdown when clicking outside
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      // Close the dropdown if the click is outside the component
      this.isOpen = false;
    }
  }
}
